import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, formatError, fmtDate, DAY_SHORT } from "@/lib/api";
import RecordsTable from "./RecordsTable";

export const VENDOR_STATUSES = ["new", "contacted", "approved", "declined"];
const STATUS_CLS = {
  new: "border-amber-500/50 text-amber-300",
  contacted: "border-sky-600/50 text-sky-300",
  approved: "border-emerald-600/60 text-emerald-300",
  declined: "border-red-700/60 text-red-300",
};

const patch = async (id, body, msg) => {
  try {
    await api.patch(`/admin/vendors/${id}`, body);
    toast.success(msg);
    return true;
  } catch (e) {
    toast.error(formatError(e));
    return false;
  }
};

const StatusSelect = ({ v }) => {
  const [status, setStatus] = useState(v.status);
  const change = async (e) => {
    const next = e.target.value;
    if (await patch(v.id, { status: next }, `Status: ${next}`)) setStatus(next);
  };
  return (
    <select value={status} onChange={change} data-testid={`vendor-status-${v.id}`} className={`h-8 rounded-full border bg-neutral-950 px-2 text-xs font-semibold capitalize ${STATUS_CLS[status]}`}>
      {VENDOR_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
    </select>
  );
};

const NotesInput = ({ v }) => {
  const [notes, setNotes] = useState(v.notes || "");
  const [saved, setSaved] = useState(v.notes || "");
  const blur = async () => {
    if (notes !== saved && (await patch(v.id, { notes }, "Notes saved"))) setSaved(notes);
  };
  return <Input value={notes} onChange={(e) => setNotes(e.target.value)} onBlur={blur} placeholder="Add a note" className="h-8 w-44 border-neutral-800 bg-neutral-950 text-xs" data-testid={`vendor-notes-${v.id}`} />;
};

export const VendorsPage = () => (
  <RecordsTable
    name="vendors"
    title="Vendors"
    filters={["day", "vendor_status"]}
    columns={[
      { key: "created_at", label: "Applied", render: (r) => <span className="whitespace-nowrap text-xs">{fmtDate(r.created_at)}</span> },
      {
        key: "business_name", label: "Business / Contact", render: (r) => (
          <div>
            <p className="font-semibold text-neutral-100">{r.business_name}</p>
            <p className="text-xs text-neutral-400">{r.contact_name}</p>
            <p className="text-xs text-neutral-500">{r.email} · {r.phone}</p>
          </div>
        ),
      },
      { key: "offerings", label: "Sells", render: (r) => <p className="max-w-xs whitespace-pre-wrap text-xs">{r.offerings}</p> },
      { key: "days", label: "Days", render: (r) => <span className="text-xs">{r.days.map((d) => DAY_SHORT[d]).join(", ")}</span> },
      { key: "status", label: "Status", render: (r) => <StatusSelect key={`${r.id}-${r.status}`} v={r} /> },
      { key: "notes", label: "Notes", render: (r) => <NotesInput key={`${r.id}-${r.notes}`} v={r} /> },
    ]}
  />
);
